import ImageIcon from './component'

export default ImageIcon
